var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('ali-player',{ref:"player",attrs:{"vid":_vm.vid,"playauth":_vm.playAuth,"encryptType":_vm.encryptType,"format":_vm.format}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }